<template>
    <div id="newsCard" class="w-[17.8125rem] cursor-pointer rounded-md border border-solid bg-white">
        <div class="flex">
            <div class="relative flex p-2">
                <img :src="detail?.thumbnail" class="w-[100px] h-[100px] max-w-[unset]  aspect-square object-cover rounded-md" alt="">
                <template v-if="detail?.has_video">
                    <div class="absolute w-[100px] h-[100px] top-2 left-2 inset-0 rounded-md bg-[rgba(0,0,0,0.74)]"></div>
                    <IconPlay class="absolute left-[50%] top-[47%] translate-x-[-50%] translate-y-[-50%] z-[1]">
                    </IconPlay>
                </template>
            </div>
            <div class="flex flex-col p-2">
                <div class="flex mb-2">
                    <p class="text-sm  line-clamp-2 text-main-color font-semibold w-[90%] overflow-hidden text-ellipsis">{{
                        detail?.name }}</p>
                </div>
                <div class="flex justify-between items-center mb-1">
                    <p class="text-sm text-main-color font-light">{{ isTodayDate(detail?.date_created) }}</p>
 
                </div>
                <div class="flex items-center">
                    <template v-if="detail?.link_type != null">
                        <a v-if="detail?.link_type == 0" :href="detail?.link" class="text-base overflow-hidden truncate  text-[#409DBA] font-semibold md:mb-0 hover:text-main-color">{{ detail?.link_text }}
                        </a>
                        <router-link v-else :to="{name: linkType[detail?.link_type].route, params: { id: detail?.link }}" class="text-base overflow-hidden truncate  text-[#409DBA] font-semibold md:mb-0 hover:text-main-color">{{ detail?.link_text }}
                        </router-link>
                    </template>
                </div>
            </div>
        </div>
        <div style="background-color: rgba(96, 165, 250, 0.69);" class="px-2 py-0.5 text-sm rounded-sm" v-if="showCategory">{{ detail.category }}</div>
    </div>
</template>

<script>
import { isTodayDate } from '@/helpers';
import IconEye from '@icons/IconEye.vue'
import IconPlay from '@icons/IconPlay.vue'
import { LINK_TYPE } from '@/constants'
export default {
    name: "NewsTile",
    props: {
        detail: {
            type: Object,
            required: true
        },
        showCategory: {
            type: Boolean,
            default: () => false,
        }
    },
    components: { IconEye, IconPlay },
    data(){
        return {
            linkType: LINK_TYPE
        }
    },
    methods: {
        isTodayDate
    },
    computed: {
        isVideo(){
            if (this.detail?.thumbnail){
                let conditions = [".mp4", ".mov", ".avi", ".mkv", ".webm"]
                let fragments = this.detail?.thumbnail.split('.') 
                fragments = fragments[fragments.length-1]
                return conditions.some(el => fragments.includes(el));
            }
            return false
        }
    }
}
</script>

<style scoped></style>